/**
 * Google Analytics 4 Page View Tracker for React SPA
 *
 * This component tracks page views when users navigate between pages
 * in the Single Page Application. Without this, GA4 would only track
 * the initial page load, not subsequent navigation.
 */

import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";

const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Send pageview to Google Analytics whenever the path changes
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
      title: document.title,
    });
  }, [location]);

  return null;
};

export default AnalyticsTracker;
